"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Contract_Offer = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_Contract_Party_1 = require("./RTTI_Contract_Party");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Contract_Answer_1 = require("./RTTI_Contract_Answer");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_unsignedInt_1 = require("../Scalar/RTTI_unsignedInt");
exports.RTTI_Contract_Offer = t.recursion('IContract_Offer', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
        party: t.array(RTTI_Contract_Party_1.RTTI_Contract_Party),
        topic: RTTI_Reference_1.RTTI_Reference,
        type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        decision: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        decisionMode: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        answer: t.array(RTTI_Contract_Answer_1.RTTI_Contract_Answer),
        text: t.string,
        _text: RTTI_Element_1.RTTI_Element,
        linkId: t.array(t.string),
        _linkId: t.array(RTTI_Element_1.RTTI_Element),
        securityLabelNumber: t.array(RTTI_unsignedInt_1.RTTI_unsignedInt),
        _securityLabelNumber: t.array(RTTI_Element_1.RTTI_Element)
    });
});
//# sourceMappingURL=RTTI_Contract_Offer.js.map